<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Đối soát MC ưu đãi khi mở BIDV</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button class="font-medium f12 btn btn-outline-secondary" @click="onShowImportUpload">
          <i class="bx bx-download"></i><span>&nbsp;</span>Import File
        </button>
        <button class="font-medium f12 btn btn-outline-secondary" @click="exportExcel">
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất Excel
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khóa"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionId"
              :options="dataConfigRegion"
              placeholder="Vùng kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="Config.statusMcBIDV"
              placeholder="Trạng thái đối soát"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian tạo bản ghi"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo bản ghi
                </label>
              </template>
            </DateRangePicker>
          </div>
          <!-- <div class="form-group">
            <DateRangePicker
              placeholder = "Thời gian cập nhật"
              class="w-100"
              :ranges="false"
              @update="transformDateUpdate()"
              v-model="dateRangeUpdate"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label v-if="picker.startDate && picker.endDate" style="min-width: 13.5em" class="text-center font-size-12">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian cập nhật
                </label>
              </template>
            </DateRangePicker>
          </div> -->

          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(time)="data">
                <span class="text-center">
                  <p>TG Tạo:{{ data.item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                  <!-- <p>TG CN:{{ data.item.modifiedDate  | formatDate('HH:mm, DD/MM/YYYY')}}</p> -->
                </span>
              </template>
              <template #cell(merchant)="data">
                <span class="text-center">
                  <p>{{ data.item.cusEmail }}</p>
                </span>
              </template>
              <template #cell(code)="data">
                <span class="text-center">
                  <p>
                    {{
                      data.item.serials.length > 1
                        ? data.item.serials.join(', ')
                        : data.item.serials[0]
                    }}
                  </p>
                </span>
              </template>
              <template #cell(codeAppendix)="data">
                <span class="text-center">
                  <p>{{ data.item.appendixCode }}</p>
                  <p>{{ data.item.contractCode }}</p>
                </span>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="data.item.status">
                  {{ data.item.status | transformData(Config.statusMcBIDV) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    @click="handleAction({ item: data.item, action: 'SUCCESS' })"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Đánh dấu đã đạt ĐK
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="handleAction({ item: data.item, action: 'PROCESSING' })"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Đánh dấu từ chối
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <ModalImportReconciliation @closeModal="onHideImportUpload"></ModalImportReconciliation>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import ModalImportReconciliation from './modal/ModalImportReconciliation.vue'
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import { ContractService } from '@/services/contract.service'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import { StaffService } from '@/services/staff.service'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchant', label: 'Merchant', thStyle: 'min-width: 150px' },
    { key: 'codeAppendix', label: 'Mã HĐ/PL', thStyle: 'min-width: 150px' },
    { key: 'code', label: 'Mã thiết bị', thStyle: 'min-width: 150px' },
    { key: 'time', label: 'Thời gian', thStyle: 'min-width: 170px' },
    { key: 'reconciledBy', label: 'Người đối soát', thStyle: 'min-width: 150px' },
    { key: 'status', label: 'Trạng thái yêu cầu gốc', thStyle: 'min-width: 150px' },
    { key: 'note', label: 'Ghi chú', thStyle: 'min-width: 150px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'mc-bidv',
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRangeUpdate: {
          startDate: null,
          endDate: null,
        },
        localeData: Config.localeData,
        dataConfigRegion: [],
      }
    },
    components: { ModalImportReconciliation },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
      StaffService.getRegions()
        .then(s => s.data?.map(s => ({ id: s.id, text: s.name })) ?? [])
        .then(s => (this.dataConfigRegion = s))
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      preareData() {
        const data = cloneDeep(this.search)
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await ContractService.listMcBIDV(params)
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.totalPage.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeUpdate = {
          startDate: null,
          endDate: null,
        }
        this.fetchData()
      },
      transformDate() {
        this.search.startDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      // transformDateUpdate () {
      //   this.search.modifiedFromDate = moment(this.dateRangeUpdate.startDate).startOf('day').add(7, 'hours').valueOf()
      //   this.search.modifiedToDate = moment(this.dateRangeUpdate.endDate).endOf('day').add(7, 'hours').valueOf()
      // },
      handleAction({ item, action }) {
        this.$bvModal
          .msgBoxConfirm('Bạn có chắc chắn muốn thực hiện hành động này không?', {
            title: 'Xác nhận',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Có',
            cancelTitle: 'Không',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            if (value) {
              this.showLoading = true
              ContractService.updateStatusMcBIDV({ id: item.id, paperActionSaveType: action })
                .then(s => {
                  if (s.code === 1000) {
                    this.showSuccessMx('Thành công')
                    this.fetchData()
                  } else {
                    this.showSuccessMx(s.message)
                  }
                })
                .catch(e => {
                  this.showFailMx(e.message)
                })
                .finally(() => {
                  this.showLoading = false
                })
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      onShowImportUpload() {
        this.$bvModal.show('import-reconciliation-file')
      },
      onHideImportUpload() {
        this.$bvModal.hide('import-reconciliation-file')
      },
      async exportExcel() {
        try {
          const params = this.preareData()
          params.pageIndex = 1
          params.pageSize = 100000
          this.showLoading = true
          await ContractService.exportReconciliation(params)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
<style scoped></style>
